// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qWsy","importantInfo":"styles_importantInfo__3Til6"};